/* ============================================================================
   VALAR theme.js — progressive enhancement only.
   Everything degrades gracefully: no JS = content is still visible & usable.
   ========================================================================== */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ----------------------------------------------------- scroll reveals */
  function initReveals() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------- sticky header */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var last = 0;
    function onScroll() {
      var y = window.scrollY || window.pageYOffset;
      header.classList.toggle('is-scrolled', y > 12);
      // hide on scroll-down, reveal on scroll-up (only past the hero)
      if (y > 480) {
        header.classList.toggle('is-hidden', y > last && y - last > 4);
      } else {
        header.classList.remove('is-hidden');
      }
      last = y;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ----------------------------------------------------- mobile drawer */
  function initDrawer() {
    var toggle = document.querySelector('[data-drawer-toggle]');
    var drawer = document.querySelector('[data-drawer]');
    if (!toggle || !drawer) return;
    var closeButton = drawer.querySelector('[data-drawer-close]');
    var lastFocus = null;
    function setOpen(open) {
      if (open) lastFocus = document.activeElement;
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', String(!open));
      toggle.setAttribute('aria-expanded', String(open));
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) {
        window.requestAnimationFrame(function () {
          (closeButton || drawer.querySelector('a, button')).focus();
        });
      } else if (lastFocus && document.contains(lastFocus)) {
        lastFocus.focus();
      }
    }
    toggle.addEventListener('click', function () {
      setOpen(!drawer.classList.contains('is-open'));
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close], a')) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
      if (e.key === 'Tab' && drawer.classList.contains('is-open')) {
        var focusable = Array.prototype.slice.call(drawer.querySelectorAll('a[href], button:not([disabled])'));
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  /* -------------------------------------------------- animated counters */
  function initCounters() {
    var nums = document.querySelectorAll('[data-count]');
    if (!nums.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      nums.forEach(function (n) { n.textContent = n.getAttribute('data-count-display') || n.getAttribute('data-count'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        var target = parseFloat(el.getAttribute('data-count'));
        var suffix = el.getAttribute('data-count-suffix') || '';
        var prefix = el.getAttribute('data-count-prefix') || '';
        var decimals = (String(target).split('.')[1] || '').length;
        var dur = 1400, start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = prefix + (target * eased).toFixed(decimals) + suffix;
          if (p < 1) requestAnimationFrame(step);
          else el.textContent = prefix + target.toFixed(decimals) + suffix;
        }
        requestAnimationFrame(step);
        // safety net: rAF throttles in background tabs — always land on the final value
        setTimeout(function () { el.textContent = prefix + target.toFixed(decimals) + suffix; }, dur + 300);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  /* ------------------------------------------------------ accordion/faq */
  function initAccordions() {
    document.querySelectorAll('[data-accordion]').forEach(function (item) {
      var btn = item.querySelector('[data-accordion-trigger]');
      var panel = item.querySelector('[data-accordion-panel]');
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
        panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
      });
    });
  }

  /* ------------------------------------------------- subtle hero parallax */
  function initParallax() {
    if (reduceMotion) return;
    var els = document.querySelectorAll('[data-parallax]');
    if (!els.length) return;
    var ticking = false;
    function update() {
      var y = window.scrollY || 0;
      els.forEach(function (el) {
        var speed = parseFloat(el.getAttribute('data-parallax')) || 0.12;
        el.style.transform = 'translate3d(0,' + (y * speed) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }

  /* ----------------------------------------------------------- theme toggle */
  function initThemeToggle() {
    var btn = document.querySelector('[data-theme-toggle]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var root = document.documentElement;
      var next = root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
      root.setAttribute('data-theme', next);
      try { localStorage.setItem('valar-theme', next); } catch (e) {}
    });
  }

  /* ------------------------------------------------------- mini cart */
  function initMiniCart() {
    var KEY = 'valar-cart';
    var IS_SHOP = typeof window.Shopify !== 'undefined' && !!window.Shopify.shop;
    var commerce = window.ValarCommerce || {};
    var activeCurrency = commerce.currency || 'GBP';
    var UPSELLS = (commerce.upsells || []).map(function (u) {
      return {
        id: u.id,
        handle: u.handle,
        variant: String(u.variant || ''),
        title: u.title,
        price: Number(u.priceCents || 0) / 100,
        img: u.img
      };
    });
    function renderUpsells(present, count) {
      var box = cart.querySelector('[data-cart-upsell]');
      if (!box) return;
      var avail = UPSELLS.filter(function (u) { return !present.has(u.variant) && !present.has(u.id); });
      if (!count || !avail.length) { box.innerHTML = ''; return; }
      box.innerHTML = '<p class="minicart__upsell-title">You may also like</p>';
      avail.forEach(function (u) {
        var row = document.createElement('div');
        row.className = 'minicart-upsell__row';
        var img = document.createElement('img'); img.src = u.img; img.alt = ''; img.loading = 'lazy';
        if (u.id === 'leanmaxx' || u.handle === 'leanmaxx-protocol') img.className = 'minicart-image--contain';
        var body = document.createElement('div'); body.className = 'minicart-upsell__body';
        var nm = document.createElement('div'); nm.className = 'minicart-upsell__name'; nm.textContent = u.title;
        var pr = document.createElement('div'); pr.className = 'minicart-upsell__price';
        pr.textContent = money(u.price);
        body.appendChild(nm); body.appendChild(pr);
        var btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'minicart-upsell__add';
        btn.setAttribute('data-add-to-cart', ''); btn.setAttribute('data-id', u.id); btn.setAttribute('data-variant', u.variant);
        btn.setAttribute('data-title', u.title); btn.setAttribute('data-price', String(u.price)); btn.setAttribute('data-img', u.img);
        btn.textContent = '+ Add';
        row.appendChild(img); row.appendChild(body); row.appendChild(btn);
        box.appendChild(row);
      });
    }
    function load() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
    function save(items) { try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {} }

    var cart = document.createElement('aside');
    cart.className = 'minicart';
    cart.id = 'MiniCart';
    cart.setAttribute('aria-hidden', 'true');
    cart.innerHTML =
      '<div class="minicart__panel" role="dialog" aria-label="Cart">' +
      '  <div class="minicart__head"><span class="minicart__title">Your cart</span>' +
      '    <button class="minicart__close" data-cart-close aria-label="Close cart"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button></div>' +
      '  <div class="minicart__items" data-cart-items></div>' +
      '  <div class="minicart__upsell" data-cart-upsell></div>' +
      '  <div class="minicart__foot">' +
      '    <div class="minicart__subtotal"><span>Subtotal</span><span data-cart-subtotal></span></div>' +
      '    <div class="minicart__savings" data-cart-savings hidden></div>' +
      '    <p class="minicart__note">Instant PDF download · lifetime access</p>' +
      '    <a href="#" class="btn btn--grad btn--lg minicart__checkout" data-cart-checkout>Checkout</a>' +
      '  </div></div>';
    document.body.appendChild(cart);
    var itemsEl = cart.querySelector('[data-cart-items]');
    var subEl = cart.querySelector('[data-cart-subtotal]');

    function setOpen(open) {
      cart.classList.toggle('is-open', open);
      cart.setAttribute('aria-hidden', String(!open));
      document.documentElement.style.overflow = open ? 'hidden' : '';
    }
    function money(n) {
      var locale = document.documentElement.lang || 'en-GB';
      try { return new Intl.NumberFormat(locale, { style: 'currency', currency: activeCurrency }).format(Number(n) || 0); }
      catch (e) { return '£' + (Number(n) || 0).toFixed(2); }
    }
    function renderShop() {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        activeCurrency = c.currency || activeCurrency;
        var count = c.item_count;
        document.querySelectorAll('[data-cart-count]').forEach(function (b) { b.textContent = String(count); b.hidden = count === 0; });
        cart.querySelector('[data-cart-checkout]').setAttribute('href', '/checkout');
        if (!c.items.length) {
          itemsEl.innerHTML = '<p class="minicart__empty">Your cart is empty.<br>Pick a plan and stop guessing.</p>';
          subEl.textContent = money(0);
          cart.querySelector('[data-cart-savings]').hidden = true;
          renderUpsells(new Set(), 0);
          return;
        }
        itemsEl.innerHTML = '';
        c.items.forEach(function (it) {
          var row = document.createElement('div'); row.className = 'minicart-item';
          var img = document.createElement('img'); img.className = 'minicart-item__img'; img.src = it.image || ''; img.alt = '';
          if (it.handle === 'leanmaxx-protocol' || /leanmaxx/i.test(it.product_title || '')) img.className += ' minicart-image--contain';
          var body = document.createElement('div'); body.className = 'minicart-item__body';
          var nm = document.createElement('div'); nm.className = 'minicart-item__name'; nm.textContent = it.product_title;
          var pr = document.createElement('div'); pr.className = 'minicart-item__price';
          var lineSave = (it.original_line_price - it.final_line_price) / 100;
          if (lineSave > 0.005) {
            pr.innerHTML = '<s>' + money(it.original_line_price / 100) + '</s> ' + money(it.final_line_price / 100) + ' <em class="minicart-item__save">You save ' + money(lineSave) + '</em>';
          } else {
            pr.textContent = money(it.price / 100) + ' · digital download';
          }
          var ctl = document.createElement('div'); ctl.className = 'minicart-item__row';
          ctl.innerHTML = '<div class="minicart-qty"><button type="button" data-q="-1" aria-label="Decrease quantity">−</button><span>' + it.quantity + '</span><button type="button" data-q="1" aria-label="Increase quantity">+</button></div>';
          var rm = document.createElement('button'); rm.type = 'button'; rm.className = 'minicart-item__remove'; rm.textContent = 'Remove';
          ctl.appendChild(rm); body.appendChild(nm); body.appendChild(pr); body.appendChild(ctl);
          row.appendChild(img); row.appendChild(body);
          function change(q) {
            fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: it.key, quantity: q }) }).then(renderShop);
          }
          ctl.querySelectorAll('[data-q]').forEach(function (btn) {
            btn.addEventListener('click', function () { change(Math.max(0, it.quantity + parseInt(btn.getAttribute('data-q'), 10))); });
          });
          rm.addEventListener('click', function () { change(0); });
          itemsEl.appendChild(row);
        });
        var savedEl = cart.querySelector('[data-cart-savings]');
        var disc = (c.original_total_price - c.total_price) / 100;
        if (disc > 0.005) {
          subEl.innerHTML = '<s style="color:var(--text-tertiary);font-weight:500;margin-right:8px">' + money(c.original_total_price / 100) + '</s>' + money(c.total_price / 100);
          savedEl.hidden = false; savedEl.textContent = 'Bundle discount applied. You are saving ' + money(disc) + '.';
        } else {
          subEl.textContent = money(c.total_price / 100);
          savedEl.hidden = true;
        }
        renderUpsells(new Set(c.items.map(function (i) { return String(i.variant_id); })), c.item_count);
      });
    }
    function render() {
      if (IS_SHOP) return renderShop();
      var items = load();
      var count = items.reduce(function (a, i) { return a + i.qty; }, 0);
      document.querySelectorAll('[data-cart-count]').forEach(function (b) {
        b.textContent = String(count);
        b.hidden = count === 0;
      });
      if (!items.length) {
        itemsEl.innerHTML = '<p class="minicart__empty">Your cart is empty.<br>Pick a plan and stop guessing.</p>';
        subEl.textContent = money(0);
        renderUpsells(new Set(), 0);
        return;
      }
      var co = cart.querySelector('[data-cart-checkout]');
      if (co) {
        var withV = items.filter(function (i) { return i.variant; });
        co.setAttribute('href', withV.length === items.length && items.length ? 'https://valarmode.com/cart/' + items.map(function (i) { return i.variant + ':' + i.qty; }).join(',') : '#');
      }
      itemsEl.innerHTML = '';
      items.forEach(function (it) {
        var row = document.createElement('div');
        row.className = 'minicart-item';
        var img = document.createElement('img');
        img.className = 'minicart-item__img'; img.src = it.img || ''; img.alt = '';
        if (it.id === 'leanmaxx' || /leanmaxx/i.test(it.title || '')) img.className += ' minicart-image--contain';
        var body = document.createElement('div');
        body.className = 'minicart-item__body';
        var nm = document.createElement('div'); nm.className = 'minicart-item__name'; nm.textContent = it.title;
        var pr = document.createElement('div'); pr.className = 'minicart-item__price';
        pr.textContent = money(it.price) + ' · digital download';
        var ctl = document.createElement('div'); ctl.className = 'minicart-item__row';
        ctl.innerHTML = '<div class="minicart-qty"><button type="button" data-q="-1" aria-label="Decrease quantity">−</button><span>' + it.qty + '</span><button type="button" data-q="1" aria-label="Increase quantity">+</button></div>';
        var rm = document.createElement('button'); rm.type = 'button'; rm.className = 'minicart-item__remove'; rm.textContent = 'Remove';
        ctl.appendChild(rm);
        body.appendChild(nm); body.appendChild(pr); body.appendChild(ctl);
        row.appendChild(img); row.appendChild(body);
        ctl.querySelectorAll('[data-q]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var d = parseInt(btn.getAttribute('data-q'), 10);
            var list = load();
            var t = list.find(function (x) { return x.id === it.id; });
            if (!t) return;
            t.qty = Math.min(9, t.qty + d);
            if (t.qty < 1) { var ix = list.indexOf(t); if (ix > -1) list.splice(ix, 1); }
            save(list); render();
          });
        });
        rm.addEventListener('click', function () {
          save(load().filter(function (x) { return x.id !== it.id; })); render();
        });
        itemsEl.appendChild(row);
      });
      var unitPrices = [];
      items.forEach(function (i) { for (var k = 0; k < i.qty; k++) unitPrices.push(i.price); });
      unitPrices.sort(function (a, b) { return b - a; });
      var full = unitPrices.reduce(function (a, p) { return a + p; }, 0);
      var savedEl = cart.querySelector('[data-cart-savings]');
      subEl.textContent = money(full);
      savedEl.hidden = true;
      renderUpsells(new Set(items.map(function (i) { return i.id; })), items.length);
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); render(); setOpen(true); return; }
      if (e.target.closest('[data-cart-close]')) { setOpen(false); return; }
      var atc = e.target.closest('[data-add-to-cart]');
      if (atc) {
        e.preventDefault();
        if (IS_SHOP && atc.getAttribute('data-variant')) {
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(atc.getAttribute('data-variant'), 10), quantity: 1 }] }) })
            .then(function () { render(); setOpen(true); })
            .catch(function () { window.location.href = '/cart/add?id=' + atc.getAttribute('data-variant') + '&quantity=1'; });
          return;
        }
        var items = load();
        var id = atc.getAttribute('data-id') || 'item';
        var found = items.find(function (x) { return x.id === id; });
        if (found) found.qty = Math.min(9, found.qty + 1);
        else items.push({ id: id, variant: atc.getAttribute('data-variant') || '', title: atc.getAttribute('data-title') || 'Program', price: parseFloat(atc.getAttribute('data-price')) || 0, img: atc.getAttribute('data-img') || '', qty: 1 });
        save(items); render(); setOpen(true);
      }
    });
    cart.addEventListener('click', function (e) { if (!e.target.closest('.minicart__panel')) setOpen(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
    render();
  }

  /* ------------------------------------------------ lovewall marquee */
  function initLovewall() {
    document.querySelectorAll('.lovewall--scroll').forEach(function (wall) {
      if (reduceMotion || window.innerWidth < 768 || wall.dataset.lwDup) return;
      wall.dataset.lwDup = '1';
      wall.querySelectorAll('.lovewall__col').forEach(function (col) {
        var clone = document.createElement('div');
        clone.setAttribute('aria-hidden', 'true');
        clone.style.display = 'contents';
        clone.innerHTML = col.innerHTML;
        col.appendChild(clone);
      });
    });
  }

  /* --------------------------------------------- radial orbital timeline */
  function initOrbital() {
    document.querySelectorAll('[data-orbital]').forEach(function (orb) {
      var nodes = Array.prototype.slice.call(orb.querySelectorAll('.orbital__node'));
      if (!nodes.length) return;
      var angle = 0;
      var auto = true;
      function radius() { return orb.offsetWidth < 480 ? 138 : 200; }
      function layout() {
        var r0 = radius();
        nodes.forEach(function (n, i) {
          var a = ((i / nodes.length) * 360 + angle) % 360;
          var rad = a * Math.PI / 180;
          var x = r0 * Math.cos(rad);
          var y = r0 * Math.sin(rad);
          n.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
          if (!n.classList.contains('is-open')) {
            n.style.zIndex = String(Math.round(100 + 50 * Math.cos(rad)));
            n.style.opacity = String(Math.max(0.4, Math.min(1, 0.4 + 0.6 * ((1 + Math.sin(rad)) / 2))));
          } else {
            n.style.opacity = '1';
          }
        });
      }
      function closeAll() {
        nodes.forEach(function (n) {
          n.classList.remove('is-open', 'is-related');
          var c = n.querySelector('.orbital__card');
          if (c) c.hidden = true;
        });
        auto = true;
      }
      nodes.forEach(function (n, i) {
        var card = document.createElement('div');
        card.className = 'orbital__card';
        card.hidden = true;
        var h = document.createElement('h4'); h.textContent = n.getAttribute('data-title') || '';
        var p = document.createElement('p'); p.textContent = n.getAttribute('data-content') || '';
        var top = document.createElement('div'); top.className = 'orbital__card-top';
        var badge = document.createElement('span'); badge.className = 'orbital__badge'; badge.textContent = n.getAttribute('data-phase') || 'PHASE';
        var date = document.createElement('span'); date.className = 'orbital__date'; date.textContent = n.getAttribute('data-date') || '';
        top.appendChild(badge); top.appendChild(date);
        card.appendChild(top); card.appendChild(h); card.appendChild(p);
        card.addEventListener('click', function (e) { e.stopPropagation(); });
        n.appendChild(card);
        n.addEventListener('click', function (e) {
          e.stopPropagation();
          var wasOpen = n.classList.contains('is-open');
          closeAll();
          if (!wasOpen) {
            n.classList.add('is-open');
            card.hidden = false;
            auto = false;
            angle = ((270 - (i / nodes.length) * 360) % 360 + 360) % 360;
            (n.getAttribute('data-related') || '').split(',').forEach(function (ri) {
              var t = nodes[parseInt(ri, 10) - 1];
              if (t && t !== n) t.classList.add('is-related');
            });
            layout();
          }
        });
      });
      orb.addEventListener('click', function () { closeAll(); });
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      layout();
      if (!reduce) {
        setInterval(function () {
          if (auto) { angle = (angle + 0.3) % 360; layout(); }
        }, 50);
      }
      window.addEventListener('resize', layout);
    });
  }

  function boot() {
    initReveals();
    initHeader();
    initDrawer();
    initCounters();
    initAccordions();
    initParallax();
    initThemeToggle();
    initLovewall();
    initOrbital();
    if (!document.getElementById('MiniCart')) initMiniCart();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Re-init in the Shopify theme editor when sections are re-rendered
  document.addEventListener('shopify:section:load', boot);
})();
